import React from 'react';
import Scorecard from './Scorecard';

function Audit() {
  return <Scorecard />;
}

export default Audit;
